import * as _4 from 'lodash4';
import { Datasource, IDatasource } from 'utility-ng-kernel';
import { Metasource } from 'utility-ts-datasource';
import { APTermSlotGroup } from '../builders/ap_term_slot_group_builder';
import { APYearSlotGroup, IAPYearSlotGroupMeta } from '../builders/ap_year_slot_group_builder';
import { IAPTermSlotGroupDatasource } from './ap_term_slot_group_datasource';

export interface IAPYearSlotGroupDatasource extends IDatasource<APYearSlotGroup, {}, IAPYearSlotGroupMeta> {}

angular
  .module('capability-ng-academic-planner')
  .factory('ngAPYearSlotGroupDatasource', (ngAPTermSlotGroupDatasource: IAPTermSlotGroupDatasource) => {
    return new Datasource<APYearSlotGroup, {}, IAPYearSlotGroupMeta>({
      builderType: APYearSlotGroup,
      updateMode: 'merge'
    }).includeMetasource<IAPYearSlotGroupMeta>((datasource: any) => {
      return new Metasource<APYearSlotGroup, IAPYearSlotGroupMeta>(datasource).includeAttribute(
        '_term_slot_group',
        (yearSlot: APYearSlotGroup) => {
          const terms = _4.filter(ngAPTermSlotGroupDatasource.read(), { year_slot_group: yearSlot.id });
          return terms ? terms : [];
        }
      );
    });
  });



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/global/datasources/ap_year_slot_group_datasource.ts